<style lang="less">
	.chat_wrapper{
		height: 100%;
		position: relative;
		// display: grid;
		#chats{
			// padding-top: 25px;
			height: 60%;
			font-size: 0.8em;
			overflow-y: scroll;
		}
		#chat-input{
			position: absolute;
			bottom: 0px
		}
	}

</style>
<template>
	<div v-if="video_room" class="chat_wrapper">
		<div id="chats" class="ma-3">
			<div class="chatItem" v-for="(chat, i) in chats" :key="i">
				<b>{{screenNames[chat.user]}}: </b>{{chat.message}}<br/>
				<span class="overline">{{ chat.created.toDate() | moment("DD/MM/YYYY, HH:mm") }}</span>
			</div>
			<div id="bottom"></div>
		</div>
		<div id="chat-input">
			<v-textarea rows="1" filled class="ma-3" @blur="typing = false" v-on:keyup.enter="sendMessage" placeholder="..." v-model="newMessage"> </v-textarea>
		</div>
	</div>
 </template>
<script>

	import Vuex from "vuex"; 		
	export default {
		name: 'VideoChat',
		props: {
			room: {}
		},
		data: () => {
			return {
				newMessage: '', 
				typing: false
			}
		},
		computed: {
			...Vuex.mapState({
				user: state => state.auth.user,
				video_room: state => state.video, 
				participant: state => state.video.participant, 
				participants: state => state.video.participants || [], 
				chats: state => state.video.chats,
				// typing: state => state.video.typing
			}),
			screenNames: function(){
				var obj = {};
				this.participants.forEach( p => { 
					obj[p.user] = p.screenName
				})
				return obj;
			}
		},
		watch: {
			newMessage:function(){
				this.typing = true
			},
			// typing: function(){
			// 	const self = this;
			// 	self.$store.dispatch("updateDoc", {
			// 		doc: "videoRooms/" + self.room + "/typing/" + self.user.id, 
			// 		action: "set",
			// 		data: {typing: self.typing}
			// 	})
			// }, 
			chats(){
				this.$emit("newChat")
				// let bottom = document.getElementById("bottom");
				// if( bottom ){
				// 	setTimeout(function(){
				// 		bottom.scrollIntoView();
				// 	}, 100)
				// }
			}
		},
		methods:{
			sendMessage: function(){
				var self = this;
				let update = { user:  self.user.uid, message: self.newMessage };
				self.$store.dispatch("addDoc", {
					collection: "videoRooms/" + self.room + "/chats"  , 
					data: update
				}).then( () => self.newMessage = '' )
			} 
		}, 
		created(){
			this.$store.dispatch("video/fetchChats")
		}
	}
</script>